/* global __CLIENT__ */

import { configureStore } from '@reduxjs/toolkit';
import { serialize } from 'cookie';
import syncBreakpointWithStore from '../helpers/redux-breakpoint-ssr';
import createRootReducer from './reducers';
import {
    setAuth, setBrowserHash, setSessionHash,
} from '../components/profile/actions/ProfileActions';
import { createSessionHash, createBrowserHash } from '../helpers/Tracking';

export default function initStore(headerInfo, cookies) {
    // thunk is included by default; the dev-only serializable check warns if a Date or other non-serializable value reaches state or actions
    const store = configureStore({
        reducer: createRootReducer(headerInfo),
        preloadedState: typeof window !== 'undefined' ? window.__PRELOADED_STATE__ : undefined,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ immutableCheck: false }),
    });

    if (__CLIENT__) {
        // check the cookies only on the client to (probably) avoid problems with caching
        if (cookies) {
            if (cookies.auth_jwt) {
                store.dispatch(setAuth(cookies.auth_jwt));
            }

            if (cookies.a1_browserHash) {
                store.dispatch(setBrowserHash(cookies.a1_browserHash));
            } else {
                const browserHash = createBrowserHash();

                store.dispatch(setBrowserHash(browserHash));

                // set the cookie
                document.cookie = serialize('a1_browserHash', browserHash, {
                    domain: window.location.host.indexOf('localhost') === -1 ? 'antena1.com.br' : 'localhost', // the cookie should be usable on all antena 1 domains...
                    path: '/',
                    sameSite: 'strict',
                    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 10), // 10 years
                });
            }
        }

        // create and set the session hash. Currently we are creating a new session hash on every server request (as the subsequent navigation is client side)
        // in the future we might want to establish a better way, like a cookie with 5 minute expiration time...
        const sessionHash = createSessionHash();

        store.dispatch(setSessionHash(sessionHash));
    }

    syncBreakpointWithStore(store);

    return store;
}
